import { createSlice } from "@reduxjs/toolkit";
import type { ShiftInfo } from "../../../meltshop/models/Catalogs";
import type { EAFProcessByShift } from "../../../meltshop/models/ProcessByShift";

const EAFProcessesInitialState: {
  isLoadingPage: boolean;
  isLoadingBackground: boolean;
  isLoadingGrid: boolean;
  errorMessage: string;
  notificationMessage: string;
  processSelected: number | null;
  shiftId: number | null | false;
  shiftInfo: ShiftInfo;
  processes: EAFProcessByShift[];
  selectedProcess: EAFProcessByShift | null;
  anchorPoint: any;
} = {
  isLoadingPage: false,
  isLoadingBackground: false,
  isLoadingGrid: false,
  shiftInfo: {
    CurrentShiftId: 0,
    CurrentProductionDate: new Date(),
    CurrentProductionShift: 0,
    CurrentShift: "",
    CurrentCrew: "",
    CurrentStart: null,
    CurrentEnd: null,
    PreviousShiftId: 0,
    PreviousProductionDate: null,
    PreviousProductionShift: 0,
    PreviousShift: "",
    PreviousCrew: "",
    PreviousStart: null,
    PreviousEnd: null,
    NextShiftId: 0,
    NextProductionDate: null,
    NextProductionShift: 0,
    NextShift: "",
    NextCrew: "",
    NextStart: null,
    NextEnd: null,
  },
  processes: [],
  selectedProcess: null,
  errorMessage: "",
  notificationMessage: "",
  processSelected: null,
  shiftId: false,
  anchorPoint: {
    x: 0,
    y: 0,
  },
};

export const EAFProcessesReducer = createSlice({
  name: "__",
  initialState: EAFProcessesInitialState,
  reducers: {
    setIsLoadingPage(state, { payload }) {
      state.isLoadingPage = payload;
    },
    setIsLoadingBackground(state, { payload }) {
      state.isLoadingBackground = payload;
    },
    setIsLoadingGrid(state, { payload }) {
      state.isLoadingGrid = payload;
    },
    setShiftInfo(state, { payload }) {
      state.shiftInfo = payload;
    },
    setProcesses(state, { payload }) {
      state.processes = payload;
    },
    setSelectedProcess(state, { payload }) {
      state.selectedProcess = payload;
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setNotificationMessage(state, { payload }) {
      state.notificationMessage = payload;
    },
    setProcessSelected(state, { payload }) {
      state.processSelected = payload;
    },
    setShiftId(state, { payload }) {
      state.shiftId = payload;
    },
    setAnchorPointX(state, { payload }) {
      state.anchorPoint.x = payload;
    },
    setAnchorPointY(state, { payload }) {
      state.anchorPoint.y = payload;
    },
  },
});
